{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "CMA Tract ID",
      "folder": "Header",
      "width": 160,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "agreement_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Agreement Number",
      "folder": "Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "tract": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Tract",
      "folder": "Header",
      "width": 75,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "current_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Status",
      "folder": "Header",
      "isShownByDefault": true,
    },
  },
  "cma_type": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "MINERAL OPERATIONS AUTHORIZATION",
        "SEQUESTRATION EVALUATION",
        "WELL ACID GAS",
        "WELL CORING/CORE-HOLE",
        "WELL DISPOSAL/INJECTION",
        "WELL DRILL AND LOG",
        "WELL GAS DISSOLVED IN WATER",
        "WELL LINKAGE",
        "WELL OBSERVATION",
        "WELL OVER HOLE",
        "WELL PORE SPACE",
        "WELL RE-ENTRY",
        "WELL REPAIR AND RE-ABANDONMENT",
        "WELL ROAD ALLOWANCE",
        "WELL WATER SOURCE",
        "OTHERS",
      ],
    },
    "ui": {
      "label": "Agreement Type",
      "folder": "Header",
      "width": 175,
      "isShownByDefault": true,
    },
  },
  "land_id_hyphenated": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Land ID (DLS)",
      "folder": "Header",
      "width": 175,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "rights_str": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Rights",
      "folder": "Header",
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "A description of the rights granted by this Crown Mineral Activity",
    },
  },
  "approval_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Approval Date",
      "folder": "Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "expiry_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Expiry Date",
      "folder": "Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "designated_representative": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Designated Representative",
      "folder": "Header",
      "width": 250,
      "isShownByDefault": true,
    },
  },
  "approval_area_ha": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha",
    },
    "ui": {
      "label": "Area",
      "folder": "Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "related_wells": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Related Wells",
      "folder": "Header",
      "width": 200,
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
